import React, { Component, Fragment } from 'react';
import PopUp from '../../../../commonModules/interface/PopUp';
import FormLayout from '../containers/FormLayout';
import { isEmpty } from "lodash";
import Spin from '../../../../commonModules/interface/Spin';
import { TableRow, TableCell, Button, TableBody, IconButton } from '@material-ui/core';
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { TableLayout } from '../containers/Layout';
import { Add, CloseRounded } from '@material-ui/icons';
import { toast } from 'react-toastify';

class FormValidateOrder extends Component {
    state = {
        numberProd: 0,
        
        order_id: "",
        sales: {},
        errors: {},
    }

    componentDidMount = () => {
        this.initProdForm()
    }

    createShopList = () => {
        const list = []
        const { SHOPS, AVAILABLE } = this.props
        if( AVAILABLE ){
            Object.values(SHOPS).map( shop => { 
                // let selected = false

                // if(this.state.sale.shop === shop.id) {  // already selected   
                //     selected = true 
                // } 
                list.push (       
                    {value: shop.id, label: shop.name, disabled: !!shop.shop_disabled} 
                    )
            })
        }
        return list
    }

    handleSelectShops = (option, prodID, index) => {
        console.log("SELECT HANDLE", {option, prodID});
        const { order } = this.props;
        let value = option.value
        const max = this.findMax(prodID, value)    
        let cpProducts = [].concat(this.state.sales[prodID])
        cpProducts[index].shop_id = value
        cpProducts[index].max = max.max
        cpProducts[index].stock_id = max.stock_id

        cpProducts[index].price = order.products[index].price
        cpProducts[index].priceR = order.products[index].price
        cpProducts[index].priceHT = order.products[index].priceHT
        cpProducts[index].prod_tva_rate = order.products[index].prod_tva_rate
        cpProducts[index].priceTotal = (order.products[index].price * (cpProducts[index].quantity || 0) )
        cpProducts[index].display = option
        
        this.setState({
            ...this.state,
            shopDisplay: option,
            [prodID]: cpProducts
        })        
    }
    handleChange = (e) => {  
        const field = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only
        
        let splitTab = field.split("_")
        let prodID = splitTab[0]
        let name = splitTab[1]
        let index = splitTab[2]
        console.log("[INFO] INDEX field", splitTab);

        let cpProducts = [].concat(this.state.sales[prodID])
        if(name === "quantity") {   
            if(value === "" || regex.test(value)){// update value only if its a int
            cpProducts[index][name] = parseInt(value)
            // let discount = 0;
            // let total = 0;
            let totalQty = 0;
            
            // order price * qty
            cpProducts[index].price = Math.round(cpProducts[index].priceTotal / cpProducts[index].quantity) || cpProducts[index].priceR
            cpProducts[index].priceHT = Math.round(cpProducts[index].price / ( 1 + cpProducts[index].prod_tva_rate / 100))

                this.setState({
                    ...this.state,
                    [prodID]: cpProducts,
                })
            }
        }
    }

        
    findMax = (product_id, shop_id, list = this.props.AVAILABLE)=> { // return available stock and it's id
        let max = 0
        let stock_id = ""

        Object.values(list).map( stock => {            
            if( stock.product_id === product_id  && stock.shop_id === shop_id ) {    
                max = stock.quantity
                stock_id = stock.id

                return                    
            }
        })   
        // console.log("findMax", max,);
        return {
            max, 
            stock_id, 
        }
    }

    createAddForm = (prodID) => {
        const shopList = this.createShopList()
        
        return this.state.sales[prodID].map( (prodItems, i) => (
            <Fragment>
                <TableRow key={i} className={(this.state.errors[prodID][i].shop_id ? "has-error" : "")}>             
                    <TableCell>
                        {i !== 0 &&
                            <IconButton 
                                type="button" 
                                className="delete-line" 
                                // color="secondary"
                                onClick={() => this.handleDeleteProd(prodID, i)}
                            >
                                <CloseRounded color="error" />
                            </IconButton>
                        }
                        <InputSelectMagasin
                            options={shopList}
                            value={prodItems.display}
                            onChange={ option => this.handleSelectShops(option, prodID, i)}
                            isOptionDisabled={ option => option.disabled === true}
                            error={this.state.errors[prodID][i].shop_id}
                            label="Magasin"
                        /> 
                        {/* <small className="help-block">{this.state.errors[prodID][i].shop_id}</small> */}
                    </TableCell>

                    <TableCell className="text-center" style={{width: "150px"}}>
                        {/* <div className={"fg-line "+ (this.state.errors[prodID][0].quantity ? "has-error" : "") }>
                            <input 
                                type="number" 
                                min={1} 
                                max={prodItems.max} 
                                step={10} 
                                className="form-control input-sm" 
                                onChange={this.handleChange} 
                                value={prodItems.quantity} 
                                name={`${prodID}_quantity_${i}`} 
                                placeholder="Quantité"/>
                            <small className="help-block text-center">{prodItems.shop_id ? "Disponible : "+ prodItems.max : "" }</small>
                            <small className="help-block text-center">{this.state.errors[prodID][0].quantity}</small>
                        </div> */}
                        <InputText 
                            type="number" 
                            min={1} 
                            max={prodItems.max} 
                            step={10} 
                            change={this.handleChange} 
                            value={prodItems.quantity} 
                            name={`${prodID}_quantity_${i}`} 
                            placeholder="Quantité"
                            label="Quantité"
                        />
                    </TableCell>
                    
                </TableRow>     
                                            
            </Fragment>
        ))
    }
            
    initProdForm = () => {
        const { order } = this.props;
        let cpProd = Object.assign({}, this.state.sales)
        let cpErr = Object.assign({}, this.state.errors)
        
        order.products.forEach( prod => {
            cpProd[prod.product_id] = []
            cpErr[prod.product_id] = []
    
            cpProd[prod.product_id].push({
                display:{},
                shop_id: "",
                product_id: prod.product_id,
                quantity:"",
                max:"",
                stock_id:"",
                price:"",
                priceTotal:"",
                priceHT:"",
                prod_tva_rate: "",
            }) 
            cpErr[prod.product_id].push({
                shop_id: "",
                quantity:"",
            }) 
        })
        
        this.setState({
            ...this.state,
            sales: cpProd,
            errors: cpErr,
            numberProd: Object.keys(cpProd).length
            
        })   
    }

    handleAddProd = (prodID) => {// must add new line in the form to add a product to the sale
        let cpProd = Object.assign({}, this.state.sales)
        let cpErr = Object.assign({}, this.state.errors)

        if (isEmpty(cpProd[prodID])){
            cpProd[prodID] = []
        }
        if (isEmpty(cpErr[prodID])){
            cpErr[prodID] = []
        }
        cpProd[prodID].push({
            display:{},
            shop_id: "",
            product_id: prodID,
            quantity:"",
            max:"",
            stock_id:"",
            price:"",
            priceR:"",
            priceTotal:"",
            priceHT:"",
            prod_tva_rate: "",
        }) 
        cpErr[prodID].push({
            shop_id: "",
            quantity:"",
        }) 

        this.setState({
            ...this.state,
            sales: cpProd,
            errors: cpErr,
            numberProd: Object.keys(cpProd).length
            
        })   
    }
    handleDeleteProd = (prodID, index) => {
        let cpProd = Object.assign({}, this.state.sales)
        let cpErr = Object.assign({}, this.state.errors)

        cpProd[prodID] = [
            ...cpProd[prodID].slice(0, index),
            ...cpProd[prodID].slice(index + 1),
        ]
        cpErr[prodID] = [
            ...cpErr[prodID].slice(0, index),
            ...cpErr[prodID].slice(index + 1),
        ]

        this.setState({
            ...this.state,
            sales: cpProd,
            errors: cpErr,
            numberProd: Object.keys(cpProd).length   
        })  
    }

    validate = () => {
        const { order } = this.props;
        const { sales } = this.state;
        const required = ["quantity", "shop_id"]
        let noErrors = true
        let errors = Object.assign({}, this.state.errors)

        Object.values(sales).forEach( (prod, index) => {
            let totalQty = 0

            let orderProd = order.products[index]
            // console.log('====================================');
            // console.log({prod, order: orderProd});
            // console.log('====================================');               

            prod.forEach((shop, i) => {
                required.forEach( field => {
                    if(isEmpty(shop[field]) && !shop[field]){
                        noErrors = false
                        console.log("is empty", field, "noErrors", noErrors);
                        
                        errors[orderProd.product_id][i][field] = "Veuillez remplir ce champs"
                        
                    } else if (field === "quantity" && shop[field] > shop.max) {
                        noErrors = false
                        console.log("not enough qty", field, "noErrors", noErrors);
                        errors[orderProd.product_id][i][field] = "Stock insuffisant"
                        
                    } else {
                        errors[orderProd.product_id][i][field] = ""

                    }
                })
                totalQty += shop.quantity
            })
            
            if (totalQty !== orderProd.quantity) {
                noErrors = false
                console.log("qty equal noErrors", noErrors);
                errors[orderProd.product_id][0].quantity = "Quantité ne correspond pas à la quantité commmandée"
            }
        });

        console.log('====================================');
        console.log({errors});
        console.log({noErrors});
        console.log('====================================');
    
        this.setState({
            errors
        })

        return noErrors
    }

    handleSubmit = async () => {

        if( this.validate()){
            const { sales } = this.state;
            const { order} = this.props;
            let orderedByShop = {}
            let data = []
            
            Object.values(sales).forEach( prod => {
                prod.forEach( saleItem => {
                    if( isEmpty(orderedByShop[saleItem.shop_id]) ){
                        orderedByShop[saleItem.shop_id] = []
                    }
                    orderedByShop[saleItem.shop_id].push(saleItem)
                })
            })

            Object.keys(orderedByShop).forEach( (shopID, index) => {
                data[index] = {
                    shop_id: shopID,
                    date: new Date(),
                    nature: "order",
                    client_ref: order.shop_app_client,
                    account_id: order.account_id,
                    order_id: order.order_id,
                    products: orderedByShop[shopID]
                }
            })
            
            console.log('====================================');
            console.log("OKAY SEND TO BACK", {data});
            console.log('====================================');

            await this.props.validateOrder(data)
            if(this.props.STATE.orders.error){
                console.log("ERROR", this.props.STATE.orders.error);
                toast.error( this.props.STATE.orders.error)
            } else {
                //success 
                toast.info("Commande validée")
                this.props.handleClosePopUp()
            }      
        } else {
            console.log('====================================');
            console.log("le formulaire contient des erreurs");
            console.log('====================================');
            toast.error(  "le formulaire contient des erreurs")
        }
    }

    render() {
        const { order, PRODUCTS } = this.props;
        // console.table(this.state.sales)
        // console.table(this.state.errors)
        console.log('====================================');
        console.log(this.props);
        console.log('====================================');
        const submitBtn = (
            <button className="btn btn-warning" onClick={this.handleSubmit}>
                Valider
            </button>
        )
        return (
            <PopUp title="Valider la commande" submit={submitBtn} close={this.props.handleClosePopUp}>
                {this.props.STATE.orders.fetching && <Spin />}
                <TableLayout>
                    <TableBody>
                        {this.state.numberProd >= (order.products.length) && 
                            order.products.map( prod => (
                                <FormLayout title={`${PRODUCTS[prod.product_id].name} x${prod.quantity}`} order>
                                    
                                    {this.createAddForm(prod.product_id)}
                                    {prod.quantity > 1 &&
                                        <TableRow className="plus-btn" onClick={() => this.handleAddProd(prod.product_id)}>
                                            <TableCell colSpan={4}>
                                                <a> 
                                                    {/* <i className="zmdi zmdi-plus-circle-o zmdi-hc-fw"></i> */}
                                                    <Add />
                                                    <span>Ajouter un Magasin</span> 
                                                </a>
                                            </TableCell>
                                        </TableRow>
                                    }      
                                </FormLayout>
                            )) 
                        }
                        
                    </TableBody>
                </TableLayout>
            </PopUp>

        );
    }
}

export default FormValidateOrder;